import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { FitnessHero } from '@/components/fitness/FitnessHero';
import { Transformations } from '@/components/fitness/Transformations';
import { ClientStories } from '@/components/fitness/ClientStories';
import { CoachingOptions } from '@/components/fitness/CoachingOptions';
import { WhoThisIsFor } from '@/components/fitness/WhoThisIsFor';
import { TheMethod } from '@/components/fitness/TheMethod';
import { TheProcess } from '@/components/fitness/TheProcess';
import { FitnessFAQ } from '@/components/fitness/FitnessFAQ';
import { FitnessCTA } from '@/components/fitness/FitnessCTA';
import { FitnessContactForm } from '@/components/fitness/FitnessContactForm';

export default function FitnessPage() {
  return (
    <div className="min-h-screen bg-black" data-testid="fitness-page">
      <Header />
      <FitnessHero />
      <Transformations />
      <ClientStories />
      <CoachingOptions />
      <WhoThisIsFor />
      <TheMethod />
      <TheProcess />
      <FitnessFAQ />
      <FitnessCTA />
      <FitnessContactForm />
      <Footer />
    </div>
  );
}
